import React from "react";
import PropTypes from "prop-types";

import Loader from "../../UI/Loader";
import Viewer from "../../UI/Viewer";
import ChapterBar from "../ChapterBar/ChapterBar";
import SwipableChapterLayout from "./SwipableChapterLayout";
import StandardChapterLayout from "./StandardChapterLayout";
import { isMobileDevice } from "../../../utils/mobile";
import { withAudio } from "../ChapterAudio/ChapterAudio";
import { withChapter } from "../ChapterContainer";
import { withBible } from "../../Bible/BibleContainer";
import { ChapterFooter } from "./ChapterFooter";
import { ChapterMode, CHAPTER_MODES } from "./ChapterMode";
import { ChapterScroller } from "./ChapterScroller";

const ChapterLayout = ({
  bible: { parallelBibleIds = [] },
  chapter: { isLoading = false },
  audio
}) => {
  const isMobile = isMobileDevice();
  const platformType = isMobile ? "phone" : "desktop";
  const numOfParallels = parallelBibleIds.length;

  return (
    <ChapterMode hasParallels={numOfParallels > 0}>
      {({
        mode,
        setModeAudioSync,
        setModeDefault,
        decrementScrollLocks,
        incrementScrollLocks
      }) => (
        <Viewer
          wide={parallelBibleIds.length > 0}
          numOfParallels={numOfParallels}
        >
          <div
            style={{
              opacity:
                isMobile ||
                mode === CHAPTER_MODES.DEFAULT ||
                mode === CHAPTER_MODES.AUDIO_USER_SCROLLING
                  ? 1
                  : 0
            }}
          >
            <ChapterBar
              platformType={platformType}
              setModeDefault={setModeDefault}
            />
          </div>
          <Loader isLoading={isLoading()} isSwipable={isMobile} />
          {isMobile ? (
            <SwipableChapterLayout
              platformType={platformType}
              setModeDefault={setModeDefault}
            />
          ) : (
            <StandardChapterLayout
              platformType="desktop"
              setModeDefault={setModeDefault}
            />
          )}
          <ChapterFooter
            audioIsPlayable={audio.isPlayable}
            mode={mode}
            setModeDefault={setModeDefault}
            setModeAudioSync={setModeAudioSync}
          />
          <ChapterScroller
            mode={mode}
            currentAudioVerseElement={audio.currentAudioVerseElement}
            currentAudioVerseId={audio.currentAudioVerseId}
            incrementScrollLocks={incrementScrollLocks}
            decrementScrollLocks={decrementScrollLocks}
          />
        </Viewer>
      )}
    </ChapterMode>
  );
};

ChapterLayout.propTypes = {
  isLoading: PropTypes.bool,
  audio: PropTypes.shape({
    isPlayable: PropTypes.bool.isRequired
  }).isRequired,
  chapter: PropTypes.shape({
    isLoading: PropTypes.func.isRequired
  }).isRequired,
  bible: PropTypes.shape({
    parallelBibleIds: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};

export default withBible(withChapter(withAudio(ChapterLayout)));
